// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "v1.35.18/js/" + chunkId + "." + __webpack_require__.h() + ".js";
};